import React, { Component } from 'react';
import './App.css';
import Tone from 'tone';
import P5Wrapper from 'react-p5-wrapper';

const meter = new Tone.Meter();

const beat1 = new Tone.Player({
  "url": "beat1.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 32.54,
  "volume": -Infinity
}).connect(meter).toMaster();

const beat2 = new Tone.Player({
  "url": "beat2.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 32.54,
  "volume": -Infinity
}).connect(meter).toMaster();

const bass1 = new Tone.Player({
  "url": "bass1.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 32.54,
  "volume": -Infinity
}).connect(meter).toMaster();

const bass2 = new Tone.Player({
  "url": "bass2.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 32.54,
  "volume": -Infinity
}).connect(meter).toMaster();

const melody1 = new Tone.Player({
  "url": "melody1.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 32.54,
  "volume": -Infinity
}).connect(meter).toMaster();

const melody2 = new Tone.Player({
  "url": "melody2.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 32.54,
  "volume": -Infinity
}).connect(meter).toMaster();

const final = new Tone.Player({
  "url": "chorus-piano.mp3",
  "volume": 10
}).toMaster();

const players = [beat1, beat2, bass1, bass2, melody1, melody2];

class Chaos extends Component {

  constructor() {
    super();

    this.state = {
      phase0: true,
      phase1: false
    }

    this.begin = this.begin.bind(this);
  }

  componentDidMount() {
    console.log("12");
  }

  begin() {
    this.setState({
      phase0: false,
      phase1: true
    });
    for (var i = 0; i < players.length; i++) {
      players[i].start();
    };
  }

  render() {
    return (
      <div className="App">
        <div className="content">
          <div className={this.state.phase0 === true ? "begin" : "phase0-hide"}>
            <img className="begin-img" src="begin.png" alt="begin" onClick={() => {
              this.begin();
            }} />
          </div>
          <div className={this.state.phase1 === true ? "sketch" : "phase1-hide"}>
            <P5Wrapper sketch={sketch} />
          </div>
        </div>
      </div>
    );
  }
}

function sketch(p) {

  var relocate;
  var resolve;
  var exit;
  var itsover;
  var cellWidth = p.windowWidth / 4;
  var cellHeight = p.windowHeight / 4;
  var imgTopCornerX = (cellWidth * 2) - (100 / 2);
  var imgTopCornerY = (cellHeight * 3) + ((cellHeight - 42) / 2);
  var resolveImgTopCornerX = (cellWidth * 2) - (100 / 2);
  var resolveImgTopCornerY = (cellHeight * 2) - (42 / 2);
  var exitITCX = (cellWidth * 3) + ((cellWidth - 100) / 2);
  var exitITCY = (cellHeight * 3) + ((cellHeight - 42) / 2);
  var itsoverX = -100;
  var itsoverY = -42;

  var recordedWidth = p.windowWidth;
  var recordedHeight = p.windowHeight;

  var text1;
  var text2;
  var text3;
  var text4;
  var text5;
  var text6;
  var text7;
  var text8;

  var textPositionDeterminers = [];
  var textXPositions = [];
  var textYPositions = [];

  function randomizeTextPositions() {
    for (var i = 0; i < 8; i++) {
      let n = Math.floor(Math.random() * 2);
      textPositionDeterminers.push(n);
      if (n === 0) {
        textXPositions.push(-150);
      }
      else {
        textXPositions.push(p.windowWidth);
      }
      textYPositions.push(Math.floor(Math.random() * p.windowHeight));
    }
  }

  randomizeTextPositions();

  var randomXSetForTwoCell = [];
  var randomYSetForTwoCell = [];
  var randomXSetForOneCell = [];
  var randomYSetForOneCell = [];

  for (var h = 0; h < 6; h++) {
    let randomXForTwoCell = Math.floor(Math.random() * 3);
    randomXSetForTwoCell.push(randomXForTwoCell);
    let randomYForTwoCell = Math.floor(Math.random() * 3);
    randomYSetForTwoCell.push(randomYForTwoCell);
    let randomXForOneCell = Math.floor(Math.random() * 4);
    randomXSetForOneCell.push(randomXForOneCell);
    let randomYForOneCell = Math.floor(Math.random() * 4);
    randomYSetForOneCell.push(randomYForOneCell);
  }

  var triggers = [false, false, false, false, false, false];

  p.preload = function preload() {
    relocate = p.loadImage("relocate.png");
    resolve = p.loadImage("resolve.png");
    exit = p.loadImage("exit.png");
    itsover = p.loadImage("itsover_w.png");
    text1 = p.loadImage("smaller/wherediditgo.png");
    text2 = p.loadImage("smaller/wherearewegoing.png");
    text3 = p.loadImage("smaller/whatdiditmean.png");
    text4 = p.loadImage("smaller/thisisntgoingtolast.png");
    text5 = p.loadImage("smaller/faitaccompli.png");
    text6 = p.loadImage("smaller/donttrustme.png");
    text7 = p.loadImage("smaller/dontrelyonthis.png");
    text8 = p.loadImage("smaller/canitbeexplained.png");
  }

  p.setup = function () {
    p.createCanvas(p.windowWidth, p.windowHeight);
    p.cursor(p.CROSS);
    p.background(255);

  };

  p.windowResized = function windowResized() {
    p.resizeCanvas(p.windowWidth, p.windowHeight);
  };

  p.draw = function draw() {

    var level = meter.getLevel();

    p.background(100 - (level * -0.75));

    p.image(relocate, imgTopCornerX, imgTopCornerY);

    p.image(itsover, itsoverX, itsoverY);

    p.image(exit, exitITCX, exitITCY);

    p.image(text1, textXPositions[0], textYPositions[0]);
    p.image(text2, textXPositions[1], textYPositions[1]);
    p.image(text3, textXPositions[2], textYPositions[2]);
    p.image(text4, textXPositions[3], textYPositions[3]);
    p.image(text5, textXPositions[4], textYPositions[4]);
    p.image(text6, textXPositions[5], textYPositions[5]);
    p.image(text7, textXPositions[6], textYPositions[6]);
    p.image(text8, textXPositions[7], textYPositions[7]);

    if ((p.mouseX > imgTopCornerX && p.mouseX < imgTopCornerX + 100 && p.mouseY > imgTopCornerY && p.mouseY < imgTopCornerY + 42) ||
      (p.mouseX > exitITCX && p.mouseX < exitITCX + 100 && p.mouseY > exitITCY && p.mouseY < exitITCY + 42)) {
      p.cursor(p.HAND);
    }
    else {
      p.cursor(p.CROSS);
    }

    if (recordedWidth !== p.windowWidth || recordedHeight !== p.windowHeight) {

      p.image(exit, exitITCX, exitITCY);
      cellWidth = p.windowWidth / 4;
      cellHeight = p.windowHeight / 4;
      exitITCX = (cellWidth * 3) + ((cellWidth - 100) / 2);
      exitITCY = (cellHeight * 3) + ((cellHeight - 42) / 2);
      imgTopCornerX = (cellWidth * 2) - (100 / 2);
      imgTopCornerY = (cellHeight * 3) + ((cellHeight - 42) / 2);
      resolveImgTopCornerX = (cellWidth * 2) - (100 / 2);
      resolveImgTopCornerY = (cellHeight * 2) - (42 / 2);
      recordedWidth = p.windowWidth;
      recordedHeight = p.windowHeight;
    }

    function hideEverything() {
      resolveImgTopCornerX = -100;
      resolveImgTopCornerY = -42;
      itsoverX = p.windowWidth / 2 - 50;
      itsoverY = p.windowHeight / 2 - 21;
      setTimeout(() => {
        window.location = "../";
      }, 32000);
    }

    if (
      (triggers[0] === true || triggers[1] === true) &&
      (triggers[2] === true || triggers[3] === true) &&
      (triggers[4] === true)
    ) {
      p.image(resolve, resolveImgTopCornerX, resolveImgTopCornerY);
      if (p.mouseX > resolveImgTopCornerX && p.mouseX < resolveImgTopCornerX + 100 && p.mouseY > resolveImgTopCornerY && p.mouseY < resolveImgTopCornerY + 42) {
        p.cursor(p.HAND);
        if (p.mouseIsPressed) {
          p.cursor(p.WAIT);
          for (var i = 0; i < players.length; i++) {
            players[i].stop();
          };
          final.start();
          hideEverything();
        }
        else {
          p.cursor(p.HAND);
        }
      }
      else {
        p.cursor(p.CROSS);
      }
    }

    if (triggers[0] === true) {
      if (textPositionDeterminers[0] === 0) {
        textXPositions[0] = textXPositions[0] + 0.39999;
        if (textXPositions[0] > p.windowWidth) {
          textXPositions[0] = -150;
        }
      }
      else if (textPositionDeterminers[0] === 1) {
        textXPositions[0] = textXPositions[0] - 0.39999;
        if (textXPositions[0] < -150) {
          textXPositions[0] = p.windowWidth;
        }
      }
    }

    if (triggers[1] === true) {
      if (textPositionDeterminers[1] === 0) {
        textXPositions[1] = textXPositions[1] + 0.39999;
        if (textXPositions[1] > p.windowWidth ) {
          textXPositions[1] = -150;
        }
      }
      else if (textPositionDeterminers[1] === 1) {
        textXPositions[1] = textXPositions[1] - 0.39999;
        if (textXPositions[1] < -150) {
          textXPositions[1] = p.windowWidth;
        }
      }
    }

    if (triggers[2] === true) {
      if (textPositionDeterminers[2] === 0) {
        textXPositions[2] = textXPositions[2] + 0.39999;
        if (textXPositions[2] > p.windowWidth ) {
          textXPositions[2] = -150;
        }
      }
      else if (textPositionDeterminers[2] === 1) {
        textXPositions[2] = textXPositions[2] - 0.39999;
        if (textXPositions[2] < -150) {
          textXPositions[2] = p.windowWidth;
        }
      }
    }

    if (triggers[3] === true) {
      if (textPositionDeterminers[3] === 0) {
        textXPositions[3] = textXPositions[3] + 0.39999;
        if (textXPositions[3] > p.windowWidth ) {
          textXPositions[3] = -150;
        }
      }
      else if (textPositionDeterminers[3] === 1) {
        textXPositions[3] = textXPositions[3] - 0.39999;
        if (textXPositions[3] < -150) {
          textXPositions[3] = p.windowWidth;
        }
      }
    }

    if (triggers[4] === true) {
      if (textPositionDeterminers[4] === 0) {
        textXPositions[4] = textXPositions[4] + 0.39999;
        if (textXPositions[4] > p.windowWidth ) {
          textXPositions[4] = -150;
        }
      }
      else if (textPositionDeterminers[4] === 1) {
        textXPositions[4] = textXPositions[4] - 0.39999;
        if (textXPositions[4] < -150) {
          textXPositions[4] = p.windowWidth;
        }
      }
    }

    if (triggers[5] === true) {
      if (textPositionDeterminers[5] === 0) {
        textXPositions[5] = textXPositions[5] + 0.39999;
        if (textXPositions[5] > p.windowWidth ) {
          textXPositions[5] = -150;
        }
      }
      else if (textPositionDeterminers[5] === 1) {
        textXPositions[5] = textXPositions[5] - 0.39999;
        if (textXPositions[5] < -150) {
          textXPositions[5] = p.windowWidth;
        }
      }
    }

    if (triggers[0] === true && triggers[2] === true) {
      if (textPositionDeterminers[6] === 0) {
        textXPositions[6] = textXPositions[6] + 0.39999;
        if (textXPositions[6] > p.windowWidth ) {
          textXPositions[6] = -150;
        }
      }
      else if (textPositionDeterminers[6] === 1) {
        textXPositions[6] = textXPositions[6] - 0.39999;
        if (textXPositions[6] < -150) {
          textXPositions[6] = p.windowWidth;
        }
      }
    }

    if (triggers[0] === true && triggers[2] === true && triggers[4] === true) {
      if (textPositionDeterminers[7] === 0) {
        textXPositions[7] = textXPositions[7] + 0.39999;
        if (textXPositions[7] > p.windowWidth ) {
          textXPositions[7] = -150;
        }
      }
      else if (textPositionDeterminers[7] === 1) {
        textXPositions[7] = textXPositions[7] - 0.39999;
        if (textXPositions[7] < -150) {
          textXPositions[7] = p.windowWidth;
        }
      }
    }

    if (p.mouseX > cellWidth * randomXSetForOneCell[0] && p.mouseX < cellWidth * (randomXSetForOneCell[0] + 1) && p.mouseY > cellHeight * randomYSetForTwoCell[0] && p.mouseY < cellHeight * (randomYSetForTwoCell[0] + 2)) {
      players[1].volume.value = -Infinity;
      triggers[1] = false;
      if (p.mouseY > cellHeight * (randomYSetForTwoCell[0] + 0) && p.mouseY < cellHeight * (randomYSetForTwoCell[0] + 0.33)) {
        players[0].volume.value = -Infinity;
        triggers[0] = false;
      }
      if (p.mouseY > cellHeight * (randomYSetForTwoCell[0] + 0.33) && p.mouseY < cellHeight * (randomYSetForTwoCell[0] + 0.66)) {
        players[0].volume.value = -30;
        triggers[0] = false;
      }
      if (p.mouseY > cellHeight * (randomYSetForTwoCell[0] + 0.66) && p.mouseY < cellHeight * (randomYSetForTwoCell[0] + 1)) {
        players[0].volume.value = -15;
        triggers[0] = false;
      }
      if (p.mouseY > cellHeight * (randomYSetForTwoCell[0] + 1) && p.mouseY < cellHeight * (randomYSetForTwoCell[0] + 1.33)) {
        players[0].volume.value = 0;
        triggers[0] = true;
      }
      if (p.mouseY > cellHeight * (randomYSetForTwoCell[0] + 1.33) && p.mouseY < cellHeight * (randomYSetForTwoCell[0] + 1.66)) {
        players[0].volume.value = 5;
        triggers[0] = true;
      }
      if (p.mouseY > cellHeight * (randomYSetForTwoCell[0] + 1.66) && p.mouseY < cellHeight * (randomYSetForTwoCell[0] + 2)) {
        players[0].volume.value = 10;
        triggers[0] = true;
      }
      if (p.touchMoved) {
        players[1].volume.value = -Infinity;
        triggers[1] = false;
        if (p.touches[1] > cellHeight * (randomYSetForTwoCell[0] + 0) && p.touches[1] < cellHeight * (randomYSetForTwoCell[0] + 0.33)) {
          players[0].volume.value = -Infinity;
          triggers[0] = false;
        }
        if (p.touches[1] > cellHeight * (randomYSetForTwoCell[0] + 0.33) && p.touches[1] < cellHeight * (randomYSetForTwoCell[0] + 0.66)) {
          players[0].volume.value = -30;
          triggers[0] = false;
        }
        if (p.touches[1] > cellHeight * (randomYSetForTwoCell[0] + 0.66) && p.touches[1] < cellHeight * (randomYSetForTwoCell[0] + 1)) {
          players[0].volume.value = -15;
          triggers[0] = false;
        }
        if (p.touches[1] > cellHeight * (randomYSetForTwoCell[0] + 1) && p.touches[1] < cellHeight * (randomYSetForTwoCell[0] + 1.33)) {
          players[0].volume.value = 0;
          triggers[0] = true;
        }
        if (p.touches[1] > cellHeight * (randomYSetForTwoCell[0] + 1.33) && p.touches[1] < cellHeight * (randomYSetForTwoCell[0] + 1.66)) {
          players[0].volume.value = 5;
          triggers[0] = true;
        }
        if (p.touches[1] > cellHeight * (randomYSetForTwoCell[0] + 1.66) && p.touches[1] < cellHeight * (randomYSetForTwoCell[0] + 2)) {
          players[0].volume.value = 10;
          triggers[0] = true;
        }
      }
    }

    if (p.mouseX > cellWidth * randomXSetForOneCell[1] && p.mouseX < cellWidth * (randomXSetForOneCell[1] + 1) && p.mouseY > cellHeight * randomYSetForTwoCell[1] && p.mouseY < cellHeight * (randomYSetForTwoCell[1] + 2)) {
      players[0].volume.value = -Infinity;
      triggers[0] = false;
      if (p.mouseY > cellHeight * (randomYSetForTwoCell[1] + 0) && p.mouseY < cellHeight * (randomYSetForTwoCell[1] + 0.33)) {
        players[1].volume.value = -Infinity;
        triggers[1] = false;
      }
      if (p.mouseY > cellHeight * (randomYSetForTwoCell[1] + 0.33) && p.mouseY < cellHeight * (randomYSetForTwoCell[1] + 0.66)) {
        players[1].volume.value = -30;
        triggers[1] = false;
      }
      if (p.mouseY > cellHeight * (randomYSetForTwoCell[1] + 0.66) && p.mouseY < cellHeight * (randomYSetForTwoCell[1] + 1)) {
        players[1].volume.value = -15;
        triggers[1] = false;
      }
      if (p.mouseY > cellHeight * (randomYSetForTwoCell[1] + 1) && p.mouseY < cellHeight * (randomYSetForTwoCell[1] + 1.33)) {
        players[1].volume.value = 0;
        triggers[1] = true;
      }
      if (p.mouseY > cellHeight * (randomYSetForTwoCell[1] + 1.33) && p.mouseY < cellHeight * (randomYSetForTwoCell[1] + 1.66)) {
        players[1].volume.value = 5;
        triggers[1] = true;
      }
      if (p.mouseY > cellHeight * (randomYSetForTwoCell[1] + 1.66) && p.mouseY < cellHeight * (randomYSetForTwoCell[1] + 2)) {
        players[1].volume.value = 10;
        triggers[1] = true;
      }
      if (p.touchMoved) {
        players[0].volume.value = -Infinity;
        triggers[0] = false;
        if (p.touches[1] > cellHeight * (randomYSetForTwoCell[1] + 0) && p.touches[1] < cellHeight * (randomYSetForTwoCell[1] + 0.33)) {
          players[1].volume.value = -Infinity;
          triggers[1] = false;
        }
        if (p.touches[1] > cellHeight * (randomYSetForTwoCell[1] + 0.33) && p.touches[1] < cellHeight * (randomYSetForTwoCell[1] + 0.66)) {
          players[1].volume.value = -30;
          triggers[1] = false;
        }
        if (p.touches[1] > cellHeight * (randomYSetForTwoCell[1] + 0.66) && p.touches[1] < cellHeight * (randomYSetForTwoCell[1] + 1)) {
          players[1].volume.value = -15;
          triggers[1] = false;
        }
        if (p.touches[1] > cellHeight * (randomYSetForTwoCell[1] + 1) && p.touches[1] < cellHeight * (randomYSetForTwoCell[1] + 1.33)) {
          players[1].volume.value = 0;
          triggers[1] = true;
        }
        if (p.touches[1] > cellHeight * (randomYSetForTwoCell[1] + 1.33) && p.touches[1] < cellHeight * (randomYSetForTwoCell[1] + 1.66)) {
          players[1].volume.value = 5;
          triggers[1] = true;
        }
        if (p.touches[1] > cellHeight * (randomYSetForTwoCell[1] + 1.66) && p.touches[1] < cellHeight * (randomYSetForTwoCell[1] + 2)) {
          players[1].volume.value = 10;
          triggers[1] = true;
        }
      }
    }

    if (p.mouseX > cellWidth * randomXSetForTwoCell[2] && p.mouseX < cellWidth * (randomXSetForTwoCell[2] + 2) && p.mouseY > cellHeight * randomYSetForOneCell[2] && p.mouseY < cellHeight * (randomYSetForOneCell[2] + 1)) {
      players[3].volume.value = -Infinity;
      triggers[3] = false;
      if (p.mouseX > cellWidth * (randomXSetForTwoCell[2] + 0) && p.mouseX < cellWidth * (randomXSetForTwoCell[2] + 0.33)) {
        players[2].volume.value = -Infinity;
        triggers[2] = false;
      }
      if (p.mouseX > cellWidth * (randomXSetForTwoCell[2] + 0.33) && p.mouseX < cellWidth * (randomXSetForTwoCell[2] + 0.66)) {
        players[2].volume.value = -30;
        triggers[2] = false;
      }
      if (p.mouseX > cellWidth * (randomXSetForTwoCell[2] + 0.66) && p.mouseX < cellWidth * (randomXSetForTwoCell[2] + 1)) {
        players[2].volume.value = -15;
        triggers[2] = false;
      }
      if (p.mouseX > cellWidth * (randomXSetForTwoCell[2] + 1) && p.mouseX < cellWidth * (randomXSetForTwoCell[2] + 1.33)) {
        players[2].volume.value = 0;
        triggers[2] = true;
      }
      if (p.mouseX > cellWidth * (randomXSetForTwoCell[2] + 1.33) && p.mouseX < cellWidth * (randomXSetForTwoCell[2] + 1.66)) {
        players[2].volume.value = 5;
        triggers[2] = true;
      }
      if (p.mouseX > cellWidth * (randomXSetForTwoCell[2] + 1.66) && p.mouseX < cellWidth * (randomXSetForTwoCell[2] + 2)) {
        players[2].volume.value = 10;
        triggers[2] = true;
      }
      if (p.touchMoved) {
        players[3].volume.value = -Infinity;
        if (p.touches[0] > cellWidth * (randomYSetForTwoCell[2] + 0) && p.touches[0] < cellWidth * (randomYSetForTwoCell[2] + 0.33)) {
          players[2].volume.value = -Infinity;
          triggers[2] = false;
        }
        if (p.touches[0] > cellWidth * (randomYSetForTwoCell[2] + 0.33) && p.touches[0] < cellWidth * (randomYSetForTwoCell[2] + 0.66)) {
          players[2].volume.value = -30;
          triggers[2] = false;
        }
        if (p.touches[0] > cellWidth * (randomYSetForTwoCell[2] + 0.66) && p.touches[0] < cellWidth * (randomYSetForTwoCell[2] + 1)) {
          players[2].volume.value = -15;
          triggers[2] = false;
        }
        if (p.touches[0] > cellWidth * (randomYSetForTwoCell[2] + 1) && p.touches[0] < cellWidth * (randomYSetForTwoCell[2] + 1.33)) {
          players[2].volume.value = 0;
          triggers[2] = true;
        }
        if (p.touches[0] > cellWidth * (randomYSetForTwoCell[2] + 1.33) && p.touches[0] < cellWidth * (randomYSetForTwoCell[2] + 1.66)) {
          players[2].volume.value = 5;
          triggers[2] = true;
        }
        if (p.touches[0] > cellWidth * (randomYSetForTwoCell[2] + 1.66) && p.touches[0] < cellWidth * (randomYSetForTwoCell[2] + 2)) {
          players[2].volume.value = 10;
          triggers[2] = true;
        }
      }
    }

    if (p.mouseX > cellWidth * randomXSetForOneCell[3] && p.mouseX < cellWidth * (randomXSetForOneCell[3] + 1) && p.mouseY > cellHeight * randomYSetForTwoCell[3] && p.mouseY < cellHeight * (randomYSetForTwoCell[3] + 2)) {
      players[2].volume.value = -Infinity;
      triggers[2] = false;
      if (p.mouseY > cellHeight * (randomYSetForTwoCell[3] + 0) && p.mouseY < cellHeight * (randomYSetForTwoCell[3] + 0.33)) {
        players[3].volume.value = -Infinity;
        triggers[3] = false;
      }
      if (p.mouseY > cellHeight * (randomYSetForTwoCell[3] + 0.33) && p.mouseY < cellHeight * (randomYSetForTwoCell[3] + 0.66)) {
        players[3].volume.value = -30;
        triggers[3] = false;
      }
      if (p.mouseY > cellHeight * (randomYSetForTwoCell[3] + 0.66) && p.mouseY < cellHeight * (randomYSetForTwoCell[3] + 1)) {
        players[3].volume.value = -15;
        triggers[3] = false;
      }
      if (p.mouseY > cellHeight * (randomYSetForTwoCell[3] + 1) && p.mouseY < cellHeight * (randomYSetForTwoCell[3] + 1.33)) {
        players[3].volume.value = 0;
        triggers[3] = true;
      }
      if (p.mouseY > cellHeight * (randomYSetForTwoCell[3] + 1.33) && p.mouseY < cellHeight * (randomYSetForTwoCell[3] + 1.66)) {
        players[3].volume.value = 5;
        triggers[3] = true;
      }
      if (p.mouseY > cellHeight * (randomYSetForTwoCell[3] + 1.66) && p.mouseY < cellHeight * (randomYSetForTwoCell[3] + 2)) {
        players[3].volume.value = 10;
        triggers[3] = true;
      }
      if (p.touchMoved) {
        players[2].volume.value = -Infinity;
        triggers[2] = false;
        if (p.touches[1] > cellHeight * (randomYSetForTwoCell[3] + 0) && p.touches[1] < cellHeight * (randomYSetForTwoCell[3] + 0.33)) {
          players[3].volume.value = -Infinity;
          triggers[3] = false;
        }
        if (p.touches[1] > cellHeight * (randomYSetForTwoCell[3] + 0.33) && p.touches[1] < cellHeight * (randomYSetForTwoCell[3] + 0.66)) {
          players[3].volume.value = -30;
          triggers[3] = false;
        }
        if (p.touches[1] > cellHeight * (randomYSetForTwoCell[3] + 0.66) && p.touches[1] < cellHeight * (randomYSetForTwoCell[3] + 1)) {
          players[3].volume.value = -15;
          triggers[3] = false;
        }
        if (p.touches[1] > cellHeight * (randomYSetForTwoCell[3] + 1) && p.touches[1] < cellHeight * (randomYSetForTwoCell[3] + 1.33)) {
          players[3].volume.value = 0;
          triggers[3] = true;
        }
        if (p.touches[1] > cellHeight * (randomYSetForTwoCell[3] + 1.33) && p.touches[1] < cellHeight * (randomYSetForTwoCell[3] + 1.66)) {
          players[3].volume.value = 5;
          triggers[3] = true;
        }
        if (p.touches[1] > cellHeight * (randomYSetForTwoCell[3] + 1.66) && p.touches[1] < cellHeight * (randomYSetForTwoCell[3] + 2)) {
          players[3].volume.value = 10;
          triggers[3] = true;
        }
      }
    }

    if (p.mouseX > cellWidth * randomXSetForTwoCell[4] && p.mouseX < cellWidth * (randomXSetForTwoCell[4] + 2) && p.mouseY > cellHeight * randomYSetForOneCell[4] && p.mouseY < cellHeight * (randomYSetForOneCell[4] + 1)) {
      players[5].volume.value = -Infinity;
      triggers[5] = false;
      if (p.mouseX > cellWidth * (randomXSetForTwoCell[4] + 0) && p.mouseX < cellWidth * (randomXSetForTwoCell[4] + 0.33)) {
        players[4].volume.value = -Infinity;
        triggers[4] = false;
      }
      if (p.mouseX > cellWidth * (randomXSetForTwoCell[4] + 0.33) && p.mouseX < cellWidth * (randomXSetForTwoCell[4] + 0.66)) {
        players[4].volume.value = -30;
        triggers[4] = false;
      }
      if (p.mouseX > cellWidth * (randomXSetForTwoCell[4] + 0.66) && p.mouseX < cellWidth * (randomXSetForTwoCell[4] + 1)) {
        players[4].volume.value = -15;
        triggers[4] = false;
      }
      if (p.mouseX > cellWidth * (randomXSetForTwoCell[4] + 1) && p.mouseX < cellWidth * (randomXSetForTwoCell[4] + 1.33)) {
        players[4].volume.value = 0;
        triggers[4] = false;
      }
      if (p.mouseX > cellWidth * (randomXSetForTwoCell[4] + 1.33) && p.mouseX < cellWidth * (randomXSetForTwoCell[4] + 1.66)) {
        players[4].volume.value = 5;
        triggers[4] = true;
      }
      if (p.mouseX > cellWidth * (randomXSetForTwoCell[4] + 1.66) && p.mouseX < cellWidth * (randomXSetForTwoCell[4] + 2)) {
        players[4].volume.value = 10;
        triggers[4] = true;
      }
      if (p.touchMoved) {
        players[5].volume.value = -Infinity;
        triggers[5] = false;
        if (p.touches[0] > cellWidth * (randomYSetForTwoCell[4] + 0) && p.touches[0] < cellWidth * (randomYSetForTwoCell[4] + 0.33)) {
          players[4].volume.value = -Infinity;
          triggers[4] = false;
        }
        if (p.touches[0] > cellWidth * (randomYSetForTwoCell[4] + 0.33) && p.touches[0] < cellWidth * (randomYSetForTwoCell[4] + 0.66)) {
          players[4].volume.value = -30;
          triggers[4] = false;
        }
        if (p.touches[0] > cellWidth * (randomYSetForTwoCell[4] + 0.66) && p.touches[0] < cellWidth * (randomYSetForTwoCell[4] + 1)) {
          players[4].volume.value = -15;
          triggers[4] = false;
        }
        if (p.touches[0] > cellWidth * (randomYSetForTwoCell[4] + 1) && p.touches[0] < cellWidth * (randomYSetForTwoCell[4] + 1.33)) {
          players[4].volume.value = 0;
          triggers[4] = false;
        }
        if (p.touches[0] > cellWidth * (randomYSetForTwoCell[4] + 1.33) && p.touches[0] < cellWidth * (randomYSetForTwoCell[4] + 1.66)) {
          players[4].volume.value = 5;
          triggers[4] = true;
        }
        if (p.touches[0] > cellWidth * (randomYSetForTwoCell[4] + 1.66) && p.touches[0] < cellWidth * (randomYSetForTwoCell[4] + 2)) {
          players[4].volume.value = 10;
          triggers[4] = true;
        }
      }
    }

    if (p.mouseX > cellWidth * randomXSetForTwoCell[5] && p.mouseX < cellWidth * (randomXSetForTwoCell[5] + 2) && p.mouseY > cellHeight * randomYSetForOneCell[5] && p.mouseY < cellHeight * (randomYSetForOneCell[5] + 1)) {
      players[4].volume.value = -Infinity;
      triggers[4] = false;
      if (p.mouseX > cellWidth * (randomXSetForTwoCell[5] + 0) && p.mouseX < cellWidth * (randomXSetForTwoCell[5] + 0.33)) {
        players[5].volume.value = -Infinity;
        triggers[5] = false;
      }
      if (p.mouseX > cellWidth * (randomXSetForTwoCell[5] + 0.33) && p.mouseX < cellWidth * (randomXSetForTwoCell[5] + 0.66)) {
        players[5].volume.value = -30;
        triggers[5] = false;
      }
      if (p.mouseX > cellWidth * (randomXSetForTwoCell[5] + 0.66) && p.mouseX < cellWidth * (randomXSetForTwoCell[5] + 1)) {
        players[5].volume.value = -15;
        triggers[5] = false;
      }
      if (p.mouseX > cellWidth * (randomXSetForTwoCell[5] + 1) && p.mouseX < cellWidth * (randomXSetForTwoCell[5] + 1.33)) {
        players[5].volume.value = 0;
        triggers[5] = true;
      }
      if (p.mouseX > cellWidth * (randomXSetForTwoCell[5] + 1.33) && p.mouseX < cellWidth * (randomXSetForTwoCell[5] + 1.66)) {
        players[5].volume.value = 5;
        triggers[5] = true;
      }
      if (p.mouseX > cellWidth * (randomXSetForTwoCell[5] + 1.66) && p.mouseX < cellWidth * (randomXSetForTwoCell[5] + 2)) {
        players[5].volume.value = 10;
        triggers[5] = true;
      }
      if (p.touchMoved) {
        players[4].volume.value = -Infinity;
        triggers[4] = false;
        if (p.touches[0] > cellWidth * (randomYSetForTwoCell[5] + 0) && p.touches[0] < cellWidth * (randomYSetForTwoCell[5] + 0.33)) {
          players[5].volume.value = -Infinity;
          triggers[5] = false;
        }
        if (p.touches[0] > cellWidth * (randomYSetForTwoCell[5] + 0.33) && p.touches[0] < cellWidth * (randomYSetForTwoCell[5] + 0.66)) {
          players[5].volume.value = -30;
          triggers[5] = false;
        }
        if (p.touches[0] > cellWidth * (randomYSetForTwoCell[5] + 0.66) && p.touches[0] < cellWidth * (randomYSetForTwoCell[5] + 1)) {
          players[5].volume.value = -15;
          triggers[5] = false;
        }
        if (p.touches[0] > cellWidth * (randomYSetForTwoCell[5] + 1) && p.touches[0] < cellWidth * (randomYSetForTwoCell[5] + 1.33)) {
          players[5].volume.value = 0;
          triggers[5] = true;
        }
        if (p.touches[0] > cellWidth * (randomYSetForTwoCell[5] + 1.33) && p.touches[0] < cellWidth * (randomYSetForTwoCell[5] + 1.66)) {
          players[5].volume.value = 5;
          triggers[5] = true;
        }
        if (p.touches[0] > cellWidth * (randomYSetForTwoCell[5] + 1.66) && p.touches[0] < cellWidth * (randomYSetForTwoCell[5] + 2)) {
          players[5].volume.value = 10;
          triggers[5] = true;
        }
      }
    }
  };

  p.mousePressed = function mousePressed() {
    if (p.mouseX > imgTopCornerX && p.mouseX < imgTopCornerX + 100 && p.mouseY > imgTopCornerY && p.mouseY < imgTopCornerY + 42) {
      for (var i = 0; i < players.length; i++) {
        players[i].volume.value = -Infinity;
      };

      randomXSetForTwoCell = [];
      randomYSetForTwoCell = [];
      randomXSetForOneCell = [];
      randomYSetForOneCell = [];

      for (var h = 0; h < 6; h++) {
        let randomXForTwoCell = Math.floor(Math.random() * 3);
        randomXSetForTwoCell.push(randomXForTwoCell);
        let randomYForTwoCell = Math.floor(Math.random() * 3);
        randomYSetForTwoCell.push(randomYForTwoCell);
        let randomXForOneCell = Math.floor(Math.random() * 4);
        randomXSetForOneCell.push(randomXForOneCell);
        let randomYForOneCell = Math.floor(Math.random() * 4);
        randomYSetForOneCell.push(randomYForOneCell);
      }

      triggers = [false, false, false, false, false, false];



      for (var a = 0; a < 8; a++) {
        textYPositions[a] = Math.floor(Math.random() * p.windowHeight);
      }
    }

    if (p.mouseX > exitITCX && p.mouseX < exitITCX + 100 && p.mouseY > exitITCY && p.mouseY < exitITCY + 42) {
      window.location = "../";
    }
  }

  p.touchStarted = function touchStarted() {
    if (p.mouseX > imgTopCornerX && p.mouseX < imgTopCornerX + 100 && p.mouseY > imgTopCornerY && p.mouseY < imgTopCornerY + 42) {
      for (var i = 0; i < players.length; i++) {
        players[i].volume.value = -Infinity;
      };

      randomXSetForTwoCell = [];
      randomYSetForTwoCell = [];
      randomXSetForOneCell = [];
      randomYSetForOneCell = [];

      for (var h = 0; h < 6; h++) {
        let randomXForTwoCell = Math.floor(Math.random() * 3);
        randomXSetForTwoCell.push(randomXForTwoCell);
        let randomYForTwoCell = Math.floor(Math.random() * 3);
        randomYSetForTwoCell.push(randomYForTwoCell);
        let randomXForOneCell = Math.floor(Math.random() * 4);
        randomXSetForOneCell.push(randomXForOneCell);
        let randomYForOneCell = Math.floor(Math.random() * 4);
        randomYSetForOneCell.push(randomYForOneCell);
      }

      triggers = [false, false, false, false, false, false];

      for (var a = 0; a < 8; a++) {
        textYPositions[a] = Math.floor(Math.random() * p.windowHeight);
      }
    }
  }
};

export default Chaos;



// WEBPACK FOOTER //
// ./src/Chaos.js